/*
 * Copyright (c) 2026. Tooling Team
 */

import { formatCellValue } from "./formatters";
import LocalCodeCell from "../components/cells/LocalCodeCell";
import LoincCodeCell from "../components/cells/LoincCodeCell";
import LoincDescriptionCell from "../components/cells/LoincDescriptionCell";
import MappingStatusCell from "../components/cells/MappingStatusCell";
import ConfidenceCell from "../components/cells/ConfidenceCell";
import ProductUsageCell from "../components/cells/ProductUsageCell";
import UserCommentsCell from "../components/cells/UserCommentsCell";

const DefaultReadOnlyCell = (cell) => formatCellValue(cell.getValue?.());

export const LAB_DOMAIN_COLUMNS = {
  localCode: { display: "Local Code", editable: false, Cell: LocalCodeCell },
  localName: { display: "Name", editable: false, Cell: DefaultReadOnlyCell },
  localCodeSystem: {
    display: "System",
    editable: false,
    Cell: DefaultReadOnlyCell,
  },
  loincConceptCode: {
    display: "Code",
    editable: true,
    Cell: LoincCodeCell,
    size: 50,
  },
  loincConceptDescription: {
    display: "Description",
    editable: false,
    Cell: LoincDescriptionCell,
  },
  status: {
    display: "Status",
    editable: true,
    Cell: MappingStatusCell,
    size: 75,
  },
  userComments: {
    display: "Comments",
    editable: true,
    Cell: UserCommentsCell,
    size: 175,
  },
  mlProbability: {
    display: "Conf.",
    editable: false,
    Cell: ConfidenceCell,
    size: 75,
  },
  productUsage: {
    display: "Product Usage",
    editable: false,
    Cell: ProductUsageCell,
    size: 94,
  },
  loincConcept: {},
  lastEditedBy: {
    display: "Last Edited By",
    editable: false,
    Cell: DefaultReadOnlyCell,
    size: 75,
  },
};
